import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  fetchActivity,
  toggleShowMoreActivity,
  setActivityFilter,
  setActivitySearchTerm,
  setCurrentPageName
} from 'actions'
import {
  getActivityRequestByWorkspaceSlug,
  getMatchingActivity,
  getWorkspace
} from 'selectors'
import Activity from '../components/Activity'

class ActivityApp extends Component {
  render () {
    return React.createElement(Activity, this.props)
  }

  componentDidMount () {
    this.props.setCurrentPageName('activity')

    window.analytics.page('Activity', {
      workspace_id: this.props.workspace.id,
      user_id: this.props.currentUser.id
    })
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params
  const workspace = getWorkspace(state, workspaceSlug)
  const { currentUser } = state

  // data
  const { isRequesting, didRequestFail } = getActivityRequestByWorkspaceSlug(state, workspaceSlug)
  const activity = getMatchingActivity(state, workspaceSlug)

  // application
  const { isShowingMoreActivity, filter, search, hasActivity, didReceiveActivity } = state.application.workspaceActivity

  return {
    activity,
    isRequesting,
    didRequestFail,
    hasActivity,
    didReceiveActivity,
    isShowingMoreActivity,
    selectedFilter: filter,
    searchTerm: search,
    notificationsLink: `/${workspaceSlug}/settings/notifications`,
    workspace,
    currentUser
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    fetchActivity: () => dispatch(fetchActivity(ownProps.params.workspaceSlug)),
    toggleShowMore: () => dispatch(toggleShowMoreActivity()),
    setActivityFilter: filter => dispatch(setActivityFilter(filter)),
    setActivitySearchTerm: str => dispatch(setActivitySearchTerm(str)),
    setCurrentPageName: name => dispatch(setCurrentPageName(name))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityApp)



// WEBPACK FOOTER //
// ./containers/ActivityApp.js